module.exports = __webpack_public_path__ + "static/flags/RU-90982aa2ed0b5ffa025772f1251c504c.gif";